//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
  data(){
    return{
      pager:{
        page: '1',
        pageCount: '1',
      },
      parPage: '1',
      parCount: '4',
      listArrs : []
    }
  },
  mounted(){
    this.finaceList()
  },
  methods: {
    finaceList(){
      let data = 'cmd=domain_list';
      this.$http.post('https://api.abeiyun.com/www/mianbeian.php',data).then(({data})=>{
        if(data.response==200){
          this.listArrs = data.msg
          this.listArrs = data.msg.content.map((item, index) => {

            return {
              id:item.id,
              domain:item.domainname,
              ptype:item.ptype_info,
              type:item.ptype,
              cname:item.cname,
              ip:item.ip,
              time:item.setdate,
            }
          })
          this.pager.page= data.msg.curpage
          this.pager.pageCount = data.msg.allpage
        }
      })
    },
    pageNum(n,par){
      if(par=='up'){

        if(n>1){
          n = n-1;
          this.parPage = n
          this.parCount = '4';
          this.finaceList();
        }
      }else if(par=='down'){
        if(n<this.pager.pageCount){
          n = parseInt(n)+1;
          this.parPage = n
          this.parCount = '4';

          this.finaceList();
        }
      }
    },
    Delete(type,id) {
      let _this = this
      this.$vux.confirm.show({
        title: '确认',
        content: '您确定删除此绑定吗?',
        onConfirm () {
          let data = 'cmd=domain_del'+
            '&domain_type=' + type +
            '&del_id=' + id
          _this.$http.post('https://api.abeiyun.com/www/mianbeian.php',data).then(({data})=>{
            if(data.response==200){
              _this.$vux.alert.show({
                title: '提示信息',
                content: data.msg,
                onHide () {
                  _this.finaceList()
                }
              })
            }else {
              _this.$vux.alert.show({
                title: '提示信息',
                content: data.msg,
              })
            }
          })
        }
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/console/freebeian.vue